module.exports = __webpack_public_path__ + "images/gradients/gradient-ocean.0731bd22bfb08ab4e014.svg";